// extracted by mini-css-extract-plugin
module.exports = {"productsList":"products-list_productsList__JgvZ_","wrapper":"products-list_wrapper__myk9a","title":"products-list_title__sXp__"};